/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `SIGNAL_IDENTIFIED` - Trade signal identified
 * `BUYER_FOUND` - Buyer found
 * `PROPOSAL_DELIVERED` - Proposal delivered
 * `AGREEMENT_FINALISING` - Agreement finalising
 * `CLOSED_WON` - Closed won
 * `CLOSED_LOST` - Closed lost
 * `CANCELLED` - Cancelled
 */
export type TradeSignalState = (typeof TradeSignalState)[keyof typeof TradeSignalState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradeSignalState = {
  SIGNAL_IDENTIFIED: 'SIGNAL_IDENTIFIED',
  BUYER_FOUND: 'BUYER_FOUND',
  PROPOSAL_DELIVERED: 'PROPOSAL_DELIVERED',
  AGREEMENT_FINALISING: 'AGREEMENT_FINALISING',
  CLOSED_WON: 'CLOSED_WON',
  CLOSED_LOST: 'CLOSED_LOST',
  CANCELLED: 'CANCELLED',
} as const;
